import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { AppVisibilityContextProvider } from "./app-visibility/AppVisibilityContext";
import { MobileDetectionContextProvider } from "./mobile-detection/MobileDetectionContext";
import { ScrollLockContextProvider } from "./scroll-lock/ScrollLockContext";
import { ReachOutContextProvider } from "./reach-out/ReachOutContext";

const LLMContextProvider = ({ children }) => {
    return (
        <AppVisibilityContextProvider>
            <MobileDetectionContextProvider>
                <ReachOutContextProvider>
                    <ScrollLockContextProvider>{children}</ScrollLockContextProvider>
                </ReachOutContextProvider>
            </MobileDetectionContextProvider>
        </AppVisibilityContextProvider>
    );
};

export default LLMContextProvider;

LLMContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};
